import ChordSheetJS from "chordsheetjs";

class ChordProParser extends ChordSheetJS.ChordProParser {
  applyTag(tag) {
    super.applyTag(tag);

    switch (tag.name) {
      case 'start_of_bridge':
        this.startSection('bridge', tag);
        break;

      case 'end_of_bridge':
        this.endSection('bridge', tag);
        break;

      default:
        break;
    }
  }
}

export default ChordProParser;



// WEBPACK FOOTER //
// ./src/song_parser.js